module.exports = __webpack_public_path__ + "ca2ab8b0779c2591b2274342ef91ebfe.svg";